import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HttpResponse } from '@angular/common/http';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../common';
import { AlertApp } from './alerts.component';
import { AppState } from '../../../app/app.service';
import { AlertsService } from './alerts.service';
import { DatePipe } from '@angular/common';
import '../../../styles/styles.scss';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
@NgModule({
  imports: [
    BrowserModule,
    ClarityModule.forRoot(),
    VcaCommonModule,
    FormsModule,
    RouterModule.forRoot([]),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) =>
              new TranslateHttpLoader(http, 'assets/i18n/', '.json'),
          deps: [HttpClient]
      }
  })
  ],
  declarations: [
    AlertApp
  ],
  providers: [
    TranslateService,
    DatePipe,
    AppState,
    Title,
    AlertsService,
  ],
  bootstrap: [ AlertApp ],

})
export class AlertsAppModule {
}



// WEBPACK FOOTER //
// ./src/alerts/src/alerts-ui/alerts.module.ts